import React from 'react';
import './style.css';
import Logo from '../../assets/images/Desapedia-01.png';

const LoadingOverlay = () => {
  return (
    <>
      <div className='loading-overlay'>
        <div className="ripple-container">
          <div className="ripple ripple-1"></div>
          <div className="ripple ripple-2"></div>
          <div className="ripple ripple-3"></div>
          <img src={Logo} alt="Loading..." className="loading-logo-pulse" />
        </div>
      </div>
    </>
  );
};

export default LoadingOverlay;
